// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout principal */
.raICjy {
  display: flex;
  flex-direction: row;
  height: 100vh;
  min-height: 850px;
  font-family: 'Source Sans 3', sans-serif;
  width: 100%;
}

/* Coluna esquerda com imagem */
.AdWJGw {
  flex: 0 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 50%;
  padding: 8px 0 8px 8px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: var(--company-selection-bg);
}

.eUmHRQ {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.KJPhka {
  position: absolute;
  bottom: 40px;
  left: 40px;
}

/* Coluna direita com conteúdo */
.xW6yN6 {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: var(--company-selection-bg);
  padding: 40px;
  width: 50%;
  position: relative;
  overflow: hidden;
}

.xW6yN6::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 70% 45%, rgba(255, 255, 255, 0.6) 0%, transparent 35%),
    radial-gradient(circle at 20% 15%, rgba(0, 0, 0, 0.2) 0%, transparent 35%);
  filter: blur(254px);
  opacity: 0.8;
  z-index: 1;
}

.Rbq10k {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  max-width: 340px;
  width: 100%;
  position: relative;
  z-index: 2;
}

.hNgXgz {
  text-align: center;
  font-family: 'Clario', sans-serif;
  font-weight: 700;
  font-size: 27px;
  line-height: 1em;
  margin-bottom: 24px;
}

/* Card principal */
.nPJjRo {
  width: 350px;
  padding: 24px !important;
  border-radius: 4px !important;
  box-shadow: var(--card-box-shadow) !important;
  background-color: var(--company-selection-card-bg) !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 24px !important;
  position: relative;
  z-index: 2;
}

.JHorB5 {
  outline: none !important;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.JHorB5:focus {
  outline: none !important;
}

.c9cxWM {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.6;
  color: var(--text);
  text-align: left;
  width: 100%;
}

.RfEbir {
  gap: 8px;
  flex: 1;
  display: grid;
}

/* Lista de empresas */
.HY1Vah {
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 294px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: transparent;
  padding: 0 9px 0 0;
  margin: 0;
  box-sizing: border-box;
}

.HY1Vah::-webkit-scrollbar {
  width: 6px;
}

.HY1Vah::-webkit-scrollbar-track {
  background: transparent;
}

.HY1Vah::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.HY1Vah::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* Item de radio button */
.OToWLO {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 4px;
  cursor: pointer;
  border: none;
  background-color: var(--company-selection-item-bg);
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
  transition: background-color 0.2s ease;
}

.OToWLO[data-selected='true'] {
  background-color: var(--company-selection-item-selected-bg);
}

.OToWLO:hover {
  background-color: var(--company-selection-item-hover-bg);
}

.OToWLO[data-selected='true']:hover {
  background-color: var(--company-selection-item-selected-bg);
}

/* Radio button customizado */
.d1q92I {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
}

.vJMUZa {
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
}

.Oukc0J {
  width: 16px;
  height: 16px;
  border: 1px solid var(--company-selection-radio-border);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  transition: all 0.2s ease;
}

.vJMUZa:checked + .Oukc0J {
  border-color: var(--company-selection-radio-selected);
  background-color: var(--company-selection-radio-selected);
}

.pVt9Eq {
  width: 6px;
  height: 6px;
  background-color: #ffffff;
  border-radius: 50%;
}

/* Conteúdo da empresa */
.hcXhwx {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.CBpQI5 {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
}

.sEm3lD {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
}

.XmanK8 {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.z9lPYd {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Footer */
.uEaRyO {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 340px;
  position: relative;
  z-index: 2;
}

.Y7GTrX {
  font-family: 'Source Sans 3', sans-serif !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
  color: var(--company-selection-footer-link) !important;
  text-decoration: none !important;
  transition: opacity 0.2s ease !important;
}

.Y7GTrX:hover {
  opacity: 0.8 !important;
}

/* Separadores do footer */
.uEaRyO a:not(:last-child)::after {
  content: '';
  width: 1px;
  height: 8px;
  background-color: #1f1f1f;
  opacity: 0.3;
  margin-left: 16px;
}

.FZFz9A {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/CompanySelection.module.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,wCAAwC;EACxC,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,6CAA6C;EAC7C,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;8EAE4E;EAC5E,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,wBAAwB;EACxB,6BAA6B;EAC7B,6CAA6C;EAC7C,6DAA6D;EAC7D,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kDAAkD;EAClD,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uDAAuD;EACvD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mDAAmD;EACnD,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,sDAAsD;EACtD,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* Layout principal */\n.companySelectionRoot {\n  display: flex;\n  flex-direction: row;\n  height: 100vh;\n  min-height: 850px;\n  font-family: 'Source Sans 3', sans-serif;\n  width: 100%;\n}\n\n/* Coluna esquerda com imagem */\n.companySelectionLeft {\n  flex: 0 0 auto;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  width: 50%;\n  padding: 8px 0 8px 8px;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: var(--company-selection-bg);\n}\n\n.companySelectionBgImg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.companySelectionBgLogo {\n  position: absolute;\n  bottom: 40px;\n  left: 40px;\n}\n\n/* Coluna direita com conteúdo */\n.companySelectionRight {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: var(--company-selection-bg);\n  padding: 40px;\n  width: 50%;\n  position: relative;\n  overflow: hidden;\n}\n\n.companySelectionRight::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background:\n    radial-gradient(circle at 70% 45%, rgba(255, 255, 255, 0.6) 0%, transparent 35%),\n    radial-gradient(circle at 20% 15%, rgba(0, 0, 0, 0.2) 0%, transparent 35%);\n  filter: blur(254px);\n  opacity: 0.8;\n  z-index: 1;\n}\n\n.companySelectionContentWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  max-width: 340px;\n  width: 100%;\n  position: relative;\n  z-index: 2;\n}\n\n.companySelectionTitleGlobal {\n  text-align: center;\n  font-family: 'Clario', sans-serif;\n  font-weight: 700;\n  font-size: 27px;\n  line-height: 1em;\n  margin-bottom: 24px;\n}\n\n/* Card principal */\n.companySelectionCardWrapper {\n  width: 350px;\n  padding: 24px !important;\n  border-radius: 4px !important;\n  box-shadow: var(--card-box-shadow) !important;\n  background-color: var(--company-selection-card-bg) !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 24px !important;\n  position: relative;\n  z-index: 2;\n}\n\n.companySelectionForm {\n  outline: none !important;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n}\n\n.companySelectionForm:focus {\n  outline: none !important;\n}\n\n.companySelectionFormTitle {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--text);\n  text-align: left;\n  width: 100%;\n}\n\n.companySelectionButtons {\n  gap: 8px;\n  flex: 1;\n  display: grid;\n}\n\n/* Lista de empresas */\n.companySelectionList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  height: 294px;\n  width: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-color: transparent;\n  padding: 0 9px 0 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.companySelectionList::-webkit-scrollbar {\n  width: 6px;\n}\n\n.companySelectionList::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.companySelectionList::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n}\n\n.companySelectionList::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n/* Item de radio button */\n.radioItem {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  border: none;\n  background-color: var(--company-selection-item-bg);\n  width: 100%;\n  box-sizing: border-box;\n  max-width: 100%;\n  transition: background-color 0.2s ease;\n}\n\n.radioItem[data-selected='true'] {\n  background-color: var(--company-selection-item-selected-bg);\n}\n\n.radioItem:hover {\n  background-color: var(--company-selection-item-hover-bg);\n}\n\n.radioItem[data-selected='true']:hover {\n  background-color: var(--company-selection-item-selected-bg);\n}\n\n/* Radio button customizado */\n.radioButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n}\n\n.radioInput {\n  opacity: 0;\n  width: 0;\n  height: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.radioCustom {\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--company-selection-radio-border);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #ffffff;\n  transition: all 0.2s ease;\n}\n\n.radioInput:checked + .radioCustom {\n  border-color: var(--company-selection-radio-selected);\n  background-color: var(--company-selection-radio-selected);\n}\n\n.radioSelected {\n  width: 6px;\n  height: 6px;\n  background-color: #ffffff;\n  border-radius: 50%;\n}\n\n/* Conteúdo da empresa */\n.radioContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.companyInfo {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: 0;\n}\n\n.companyContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  min-width: 0;\n}\n\n.companyName {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8;\n  color: var(--text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.companyCnpj {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8;\n  color: var(--text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Footer */\n.companySelectionFooterGlobal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  width: 340px;\n  position: relative;\n  z-index: 2;\n}\n\n.companySelectionFooterLink {\n  font-family: 'Source Sans 3', sans-serif !important;\n  font-weight: 400 !important;\n  font-size: 14px !important;\n  line-height: 1.4 !important;\n  color: var(--company-selection-footer-link) !important;\n  text-decoration: none !important;\n  transition: opacity 0.2s ease !important;\n}\n\n.companySelectionFooterLink:hover {\n  opacity: 0.8 !important;\n}\n\n/* Separadores do footer */\n.companySelectionFooterGlobal a:not(:last-child)::after {\n  content: '';\n  width: 1px;\n  height: 8px;\n  background-color: #1f1f1f;\n  opacity: 0.3;\n  margin-left: 16px;\n}\n\n.button {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"companySelectionRoot": `raICjy`,
	"companySelectionLeft": `AdWJGw`,
	"companySelectionBgImg": `eUmHRQ`,
	"companySelectionBgLogo": `KJPhka`,
	"companySelectionRight": `xW6yN6`,
	"companySelectionContentWrapper": `Rbq10k`,
	"companySelectionTitleGlobal": `hNgXgz`,
	"companySelectionCardWrapper": `nPJjRo`,
	"companySelectionForm": `JHorB5`,
	"companySelectionFormTitle": `c9cxWM`,
	"companySelectionButtons": `RfEbir`,
	"companySelectionList": `HY1Vah`,
	"radioItem": `OToWLO`,
	"radioButton": `d1q92I`,
	"radioInput": `vJMUZa`,
	"radioCustom": `Oukc0J`,
	"radioSelected": `pVt9Eq`,
	"radioContent": `hcXhwx`,
	"companyInfo": `CBpQI5`,
	"companyContainer": `sEm3lD`,
	"companyName": `XmanK8`,
	"companyCnpj": `z9lPYd`,
	"companySelectionFooterGlobal": `uEaRyO`,
	"companySelectionFooterLink": `Y7GTrX`,
	"button": `FZFz9A`
};
module.exports = ___CSS_LOADER_EXPORT___;
